module.exports = __webpack_public_path__ + "img/1-1910231103164T.55849f6d.jpeg";